<template>
  <SfListItem
    :cornered="cornered"
    :item-id="itemId"
    :item-variant="itemVariant"
    font-weight="medium"
    :background="background"
    @item-click="expanded = !expanded"
  >
    <template #icon>
      <i
        class="fa"
        :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
      />
    </template>
    <template #default>
      {{ header }}
    </template>
    <template #right-content>
      <template v-if="!expanded">
        <slot name="right-content" />
      </template>
    </template>
  </SfListItem>
  <div
    v-if="expanded"
    class="
      tw-border-sf-neutral-light-1
      tw-border-s
      tw-border-y-0
      tw-border-e-0
      tw-border-solid
      tw-ps-1
      tw-ms-3
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { SfListItem, itemVariant } from '@silverfin/ui-components'
import type { ItemVariants } from '@silverfin/ui-components'
import { ref } from 'vue'

interface Props {
  header: string
  itemId: string
  background: 'default' | 'transparent'
  variant?: ItemVariants
  cornered?: boolean
  initiallyExpanded: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: itemVariant.xlg,
})

const expanded = ref(props.initiallyExpanded)
</script>
